module.exports = __webpack_public_path__ + "img/rubik-medium-webfont.68b0f9b4.68b0f9b4.svg";